import * as React from "react";
import { ThemeToggleButton } from "./theme-toggle-button";
import { StaticImage } from "gatsby-plugin-image";
import { Link } from "gatsby";
import {
  GithubSolidIcon as GithubIcon,
  GoogleScholarSolidIcon as GoogleScholarIcon,
  MailIconOutline as MailIcon,
  LinkedInSolidIcon as LinkedInIcon,
} from "../common";
import { HeaderContent } from "./content";
import { HeaderWrapper } from "./wrapper";
import styled from "styled-components";
import { TOGGLE_THEME, TO_HOME } from "../../constants";
import Tooltip from "../common/tooltip";

const ToHomeText = styled.div`
  font-size: ${({ theme }) => theme.fontSize.xl2};
  font-weight: ${({ theme }) => theme.fontWeight.bold};
  font-family: ${({ theme }) => theme.font.monospace};
`;

const RightSideWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 100%;
`;

const NavigationUl = styled.ul`
  display: flex;
  flex-direction: row;
  align-items: center;

  li {
    padding: 0 1rem 0 1rem;
    font-weight: ${({ theme }) => theme.fontWeight.bold};
    font-size: ${({ theme }) => theme.fontSize.xl};
  }
`

export const Header = ({ toggleTheme }) => {
  return (
    <HeaderWrapper>
      <HeaderContent>
        <ToHomeText>
          <Link to="/" title={TO_HOME}>Jinwoo Jeong</Link>{" | "}
            <Tooltip description="jwjeong96@gmail.com" bottom = {true}>
              <Link target={"_blank"} rel ={"noopener noreferrer"} href={"mailto:jwjeong96@gmail.com"}>
                <MailIcon size={35} />
              </Link>
            </Tooltip>
            {" "}
            <Tooltip description="Github" bottom = {true}>
              <Link target={"_blank"} rel ={"noopener noreferrer"} href={"https://github.com/bugoverdose"}>
                <GithubIcon black={false} size={25} />
              </Link>
            </Tooltip>
            {" "}
            <Tooltip description="Linkedin" bottom = {true}>
              <Link target={"_blank"} rel ={"noopener noreferrer"} href={"https://www.linkedin.com/in/jinwoo-jeong-ab284420b"}>
                <LinkedInIcon blue={false} size={25} />
              </Link>
            </Tooltip>
            {" "}
            <Tooltip description="Google Scholar" bottom = {true}>
              <Link target={"_blank"} rel ={"noopener noreferrer"} href={"https://scholar.google.com/citations?user=uhHap6gAAAAJ&hl=en"}>
                <GoogleScholarIcon black={false} size={30} />
              </Link>
            </Tooltip>
        </ToHomeText>
        <RightSideWrapper>

          <NavigationUl>
            <li>
              <ThemeToggleButton onClick={toggleTheme} title={TOGGLE_THEME}>
                <StaticImage src="./assets/dark-mode.png" alt="dark mode icon" />
                <StaticImage src="./assets/light-mode.png" alt="light mode icon" />
                <div></div>
              </ThemeToggleButton>
            </li>
            <li>
                <Link href={"/"}>Bio</Link>
            </li>
            <li>
                <Link href={"/blog"}>Blog (Ko)</Link>
            </li>
          </NavigationUl>
        </RightSideWrapper>
      </HeaderContent>
    </HeaderWrapper>
  );
};
